const normalizeAblyErrorText = (reason) => {
	if (!reason) return '';
	if (typeof reason === 'string') return reason;
	if (typeof reason?.message === 'string') return reason.message;
	if (typeof reason?.error?.message === 'string') return reason.error.message;
	if (typeof reason?.toString === 'function') {
		const rendered = reason.toString();
		return rendered === '[object Object]' ? '' : rendered;
	}
	return '';
};

export default function isIgnorableAblyConnectionError(reason) {
	const message = normalizeAblyErrorText(reason).toLowerCase();
	const code = Number(reason?.code ?? reason?.error?.code);
	return (
		message.trim() === 'unexpected server response: not connected.' ||
		message.includes('key/token status changed (revoke)') ||
		message.includes('connection to server temporarily unavailable') ||
		message.includes('connection to server unavailable') ||
		message.includes('connection closed') ||
		message.includes('websocket is closed before the connection is established') ||
		code === 80002 ||
		code === 80003 ||
		code === 80017
	);
}
